import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { LoadingService } from 'src/app/_services/loading.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

  baseUrl = environment.baseUrl;

  category_form = new FormGroup({
    id: new FormControl(null),
    category_name: new FormControl('', [Validators.required]),
    slug: new FormControl(''),
    cat_desc: new FormControl(''),
    cat_img: new FormControl(null),
    cat_banner: new FormControl(null),
    parent_category_id: new FormControl(null),
  });

  constructor(private http: HttpClient,
    private loading: LoadingService,) { }

  get_all_categories() {
    return this.http.get(this.baseUrl + '/get_all_categories');
  }

  get_categories() {
    return this.http.get(this.baseUrl + '/get_categories');
  }

  /* Insert Category */
  insert_category(formData: any, cat_img: any, cat_banner: any) {
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('category_name', formData.category_name);
    // myFormData.append('cat_slug', formData.cat_slug);
    myFormData.append('cat_desc', formData.cat_desc);
    myFormData.append('cat_img', cat_img);
    myFormData.append('cat_banner', cat_banner);
    myFormData.append('parent_category_id', formData.parent_category_id);
    console.log(myFormData);
    return this.http.post(this.baseUrl + '/create_category', myFormData, {
      headers: headers
    });
  }

  delete_category(category_id) {
    return this.http.get(this.baseUrl + '/delete_category/' + category_id);
  }

  get_category_id(category_id) {
    return this.http.get(this.baseUrl + '/get_category_id/' + category_id);
  }

  /* Update Category */
  update_category(formData: any, cat_img: any, cat_banner: any) {
    //console.log(cat_img);
    var myFormData = new FormData();
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    myFormData.append('id', formData.id);
    myFormData.append('category_name', formData.category_name);
    // myFormData.append('cat_slug', formData.cat_slug);
    myFormData.append('cat_desc', formData.cat_desc);
    myFormData.append('cat_img', cat_img);
    myFormData.append('cat_banner', cat_banner);
    myFormData.append('parent_category_id', formData.parent_category_id);
    //console.log(myFormData);
    return this.http.post(this.baseUrl + '/update_category', myFormData, {
      headers: headers
    });
  }

  update_category_status(category_id, status) {
    return this.http.get(this.baseUrl + '/update_category_status/' + category_id + '/' + status);
  }






}
